import { render, staticRenderFns } from "./SubmissionIcon.vue?vue&type=template&id=e1329116&scoped=true"
import script from "./SubmissionIcon.vue?vue&type=script&lang=js"
export * from "./SubmissionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1329116",
  null
  
)

export default component.exports